import { toUpperCaseFirst } from '@/utils/text';
import Vue from 'vue';

Vue.filter('asLang', (object, property, lang) => {
    const propertyLang = property + toUpperCaseFirst(lang);
    const propertyPl = `${property}Pl`;

    return object[propertyLang] || object[propertyPl];
});
